import { render, staticRenderFns } from "./CompetitionDetailSubjectLayout.vue?vue&type=template&id=ffb93f50&scoped=true"
import script from "./CompetitionDetailSubjectLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailSubjectLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb93f50",
  null
  
)

export default component.exports